import { render, staticRenderFns } from "./ActivityConfirmSave.vue?vue&type=template&id=167f80cb&scoped=true"
import script from "./ActivityConfirmSave.vue?vue&type=script&lang=js"
export * from "./ActivityConfirmSave.vue?vue&type=script&lang=js"
import style0 from "./ActivityConfirmSave.vue?vue&type=style&index=0&id=167f80cb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167f80cb",
  null
  
)

export default component.exports